import { StateNode } from "../StateNode.mjs";
import { Idle } from "./children/Idle.mjs";
import { Pointing } from "./children/Pointing.mjs";
import { ZoomBrushing } from "./children/ZoomBrushing.mjs";
class ZoomTool extends StateNode {
  static id = "zoom";
  static initial = "idle";
  static children = () => [Idle, ZoomBrushing, Pointing];
  info = {};
  onEnter = (info) => {
    this.info = info;
    this.updateCursor();
  };
  updateCursor() {
    if (this.editor.inputs.altKey) {
      this.editor.setCursor({ type: "zoom-out" });
    } else {
      this.editor.setCursor({ type: "zoom-in" });
    }
  }
  onExit = () => {
    this.editor.setZoomBrush(null);
    this.editor.setCursor({ type: "default" });
  };
  onKeyDown = () => {
    this.updateCursor();
  };
  onKeyUp = (info) => {
    this.updateCursor();
    if (info.code === "KeyZ") {
      this.complete();
    }
  };
  onInterrupt = () => {
    this.complete();
  };
  complete() {
    if (this.info.onInteractionEnd && this.info.onInteractionEnd !== "select") {
      this.editor.setSelectedTool(this.info.onInteractionEnd, this.info);
    } else {
      this.parent.transition("select", {});
    }
  }
}
export {
  ZoomTool
};
//# sourceMappingURL=ZoomTool.mjs.map
